module.exports = __webpack_public_path__ + "static/media/change-password.f90ad64d.svg";